import { render, staticRenderFns } from "./AssessmentListingView.vue?vue&type=template&id=72eeeeae&scoped=true&"
import script from "./AssessmentListingView.vue?vue&type=script&lang=js&"
export * from "./AssessmentListingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eeeeae",
  null
  
)

export default component.exports